<template>
    <div>
        <h1 class="sz-kath-title text-xs-center">Links</h1>
        <div class="red--text text--darken-4 " style="margin-top: 19px;">
            <div v-for="link in links"
                 @click="openLink(link.link)"
                 :key="link.link"
                 class="document-card link"
            >
                {{link.value}}

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Links",
        beforeCreate() {
            this.$store.dispatch('setViewSizeToSmall');
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        computed: {
            links () {
                return this.$store.getters.links
            }
        },
        methods: {
            openLink(link) {
                window.open(link, '_');
            }
        }

    }
</script>

<style scoped>

</style>